module.exports = __webpack_public_path__ + "img/googleLogo.a44cd089.svg";